const nonstrictWindow = window;
export const getClientID = () => process.env.CLIENT_ID || nonstrictWindow.CLIENT_ID;
export const getTenantID = () => process.env.TENANT_ID || nonstrictWindow.TENANT_ID;
export const getScopeTS = () => process.env.SCOPE_TS || nonstrictWindow.SCOPE_TS;
export const getScopeController = () => process.env.SCOPE_CONTROLLER || nonstrictWindow.SCOPE_CONTROLLER;
export const getScopeActivityAPI = () => process.env.SCOPE_ACTIVITY_API || nonstrictWindow.SCOPE_ACTIVITY_API;
export const getScopeAnnotationAPI = () => process.env.SCOPE_ANNOTATION_API || nonstrictWindow.SCOPE_ANNOTATION_API;
export const getBasename = () => process.env.BASENAME || nonstrictWindow.BASENAME || '';
export const getIsDevEnv = () => !!(process.env.IS_DEV_ENV || nonstrictWindow.IS_DEV_ENV);
export const getIsCondorApp = () => !!(process.env.IS_CONDOR_APP || nonstrictWindow.IS_CONDOR_APP);
export const AuthConfigs = {
    AUTHORITY_URL: `https://login.microsoftonline.com/${getTenantID()}/`,
    CLIENT_ID: getClientID(),
    SCOPE_GRAPH: 'https://graph.microsoft.com/user.read',
    SCOPE_OMNIA_API: 'app://omnia-prevent/user_impersonation',
    SCOPE_CONTROLLER_API: getScopeController(),
    SCOPE_TS_API: getScopeTS(),
    SCOPE_ACTIVITY_API: getScopeActivityAPI(),
    SCOPE_ANNOTATION_API: getScopeAnnotationAPI(),
    BASENAME: getBasename(),
    IS_DEV_ENV: getIsDevEnv(),
    IS_CONDOR_APP: getIsCondorApp()
};
